import type React from "react";

import type { BenefitItemProps } from "./BenefitItem";
import BenefitItem from "./BenefitItem";

import "./AdditionalBenefits.scss";

export interface AdditionalBenefitsProps extends React.JSX.IntrinsicAttributes {
  title: string;
  details: string;
  benefitsList: BenefitItemProps[];
}

export const AdditionalBenefits: React.FC<AdditionalBenefitsProps> = ({ title, details, benefitsList }) => {
  return (
    <div className={"additionalBenefits"} data-testid="additionalBenefits">
      <h1 className={"additionalBenefits__title"} data-testid="additionalBenefitsTitle">
        {title}
      </h1>
      <p className={"additionalBenefits__details"}>{details}</p>
      <div className={"additionalBenefits__benefitsList"} data-testid="additionalBenefitsItemsBlock">
        {benefitsList.map((item) => (
          <BenefitItem key={item.benefitsTitle} benefitsTitle={item.benefitsTitle} benefitsImage={item.benefitsImage} />
        ))}
      </div>
    </div>
  );
};
